/// <amd-module name="Feed/Legacy/Utils/Badge" />
import { IVssPageContext } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { FeedServiceInstanceId } from "Feed/Common/Constants/Constants";
import { getServiceRootPath } from "Feed/Legacy/Helpers/UrlHelper";
import { generateServiceRestApiUri, IRestApiRoutes } from "Feed/Legacy/Utils/RestApi";
import { Uri } from "VSS/Platform/Util/Url";

const PackagingArea: string = "Packaging";

const PackageBadgeLocation: IRestApiRoutes = {
    locationId: "61D885FD-10F3-4A55-82B6-476D866B673F",
    resource: "Badge",
    routeTemplate: "public/{area}/Feeds/{feedId}/Packages/{packageId}/{resource}"
};

export class Badge {
    // TODO: this should be coming from another webproj, not required in initial page load
    // when Enable badges is set in feed settings, create badge button will show up in hub
    public static getPackageBadgeRestUri(
        pageContext: IVssPageContext,
        feedId: string,
        packageId: string,
        projectId: string | null
    ): Uri {
        const path = replaceRouteValues(PackageBadgeLocation.routeTemplate, {
            area: PackagingArea,
            feedId,
            packageId,
            resource: PackageBadgeLocation.resource
        });

        const packagingServiceRootPath = getServiceRootPath(pageContext, FeedServiceInstanceId);
        return generateServiceRestApiUri(packagingServiceRootPath, path, false, projectId);
    }
}
